import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Link from 'shared/components/Link';
import { FormattedMessage } from 'react-intl';
import { phoneNormalize } from 'shared/modules';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import CarDriveInfo from 'shared/components/CarDriveInfo/CarDriveInfo';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import withStatsEvents from 'shared/hocs/stats/withStatsEvents';
import CarDriveForm from 'shared/components/CarDriveForm/CarDriveForm';
import DealerWebsiteLink from 'shared/components/DealerWebsiteLink/DealerWebsiteLink';
import FirmLocation from 'shared/components/FirmLocation/FirmLocation';
import DealerServices from 'shared/components/DealerServices/DealerServices';
import s from './FirmInfo.css';

class FirmInfo extends React.Component {
  static propTypes = {
    setRatioImage: PropTypes.func.isRequired,
    //
    title: PropTypes.string.isRequired,
    promo_video: PropTypes.string,
    logo: PropTypes.string.isRequired,
    cover: PropTypes.string,
    id: PropTypes.number.isRequired,
    website: PropTypes.string,
    address: PropTypes.string.isRequired,
    events: PropTypes.shape().isRequired,
    car_drive_info: PropTypes.string.isRequired,
    car_drive_countries: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    schedule: PropTypes.string.isRequired,
    phones: PropTypes.arrayOf(
      PropTypes.shape({
        number: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
      }).isRequired,
    ),
    insurance: PropTypes.bool,
    credit: PropTypes.bool,
    accessories: PropTypes.bool,
    children: PropTypes.node,
    geo_location: PropTypes.shape({ lat: PropTypes.number, lon: PropTypes.number }),
  };

  static defaultProps = {
    website: '',
    promo_video: null,
    cover: null,
    phones: [],
    children: '',
    type: 'dealer',
    trade_in: false,
    insurance: false,
    credit: false,
    accessories: false,
    geo_location: null,
  };

  state = {
    isPhoneVisible: false,
    isOpenMap: false,
    showCarDriveForm: false,
  };

  componentDidMount() {
    const { events, id } = this.props;
    events.dispatchDealerViewEvent(id);
  }

  openMap = e => {
    e.preventDefault();

    if (this.props.geo_location) {
      this.setState({ isOpenMap: true });
    }
  };

  closeMap = e => {
    e.preventDefault();
    this.setState({ isOpenMap: false });
  };

  handleShowPhoneClick = e => {
    e.preventDefault();

    const { events, id } = this.props;
    events.dispatchDealerShowPhoneEvent(id);
    this.setState({ isPhoneVisible: true });
  };

  toggleDriveForm = () => this.setState({ showCarDriveForm: !this.state.showCarDriveForm });

  render() {
    const {
      id: firmId,
      title,
      logo,
      cover: backgroundUrl,
      website,
      address,
      schedule,
      phones,
      children,
      promo_video: videoId,
      insurance,
      credit,
      accessories,
      //
      setRatioImage,
      geo_location: geoLocation,
      car_drive_info: carDriveInfo,
      car_drive_countries: carDriveCountries,
    } = this.props;

    const services = {
      insurance,
      credit,
      accessories,
    };

    const { isPhoneVisible, showCarDriveForm, isOpenMap } = this.state;

    return (
      <div className={s.root}>
        {videoId && (
          <iframe
            title={title}
            className={s.video}
            width="890"
            height="270"
            src={`https://www.youtube.com/embed/${videoId}?rel=0&controls=0&showinfo=0&loop=1&autoplay=1&mute=1&playlist=${videoId}`}
            frameBorder="0"
            gesture="media"
            allow="encrypted-media"
            allowFullScreen
          />
        )}
        {!videoId && backgroundUrl && (
          <img
            className={s.backgroundLogoImage}
            src={backgroundUrl && setRatioImage(backgroundUrl.replace('http:', 'https:'), 750)}
            alt=""
          />
        )}
        <div className={s.infoForUser}>
          <Link className={s.logoImageLink} to={`${website || ''}`}>
            <img
              alt={title}
              src={logo && setRatioImage(logo.replace('http:', 'https:'), 140)}
              className={s.logoImage}
            />
          </Link>
          <div className={s.infoForUserMain}>
            <h1 className={s.title}>{title}</h1>

            {!!address && (
              <a className={s.infoItem} onClick={this.openMap}>
                <i className={`fa fa-map-marker ${s.infoItemIcon}`} />
                <span>{address}</span>
              </a>
            )}

            {!!schedule && (
              <pre className={s.infoItem}>
                <i className={`fa fa-clock-o ${s.infoItemIcon}`} />
                {schedule}
              </pre>
            )}
            <CarDriveInfo carDriveInfo={carDriveInfo} carDriveCountries={carDriveCountries} />
            {!!services && <DealerServices services={services} />}
          </div>

          <div className={s.infoLinks}>
            {!!website && (
              <DealerWebsiteLink dealer={{ website }} ClassName={s.logoBtnLink}>
                <img src="" alt="" />
                <FormattedMessage id="Сайт" />
                &nbsp;
                <FormattedMessage id={'компании'} />
              </DealerWebsiteLink>
            )}
            <Link onClick={this.toggleDriveForm} className={s.logoBtnLink}>
              <FormattedMessage id={'Подать заявку'} />
            </Link>
            {phones.length > 0 && (
              <button
                disabled={isPhoneVisible}
                className={cx(s.phonesBlock, { [s.showedPhones]: isPhoneVisible })}
                onClick={this.handleShowPhoneClick}
              >
                {!isPhoneVisible ? (
                  <div>
                    <FormattedMessage id="Показать телефон" />
                    <div>+••• •• ••• •• ••</div>
                  </div>
                ) : (
                  <div className={s.phonesContainer}>
                    {phones.map(({ number: phone, id }) => (
                      <a key={id} className={s.phoneItem} href={`tel:${phoneNormalize(phone)}`}>
                        {phoneNormalize(phone)}
                      </a>
                    ))}
                  </div>
                )}
              </button>
            )}
          </div>
        </div>

        {children}
        <FirmLocation
          modalCN={s.modalWindow}
          isOpen={isOpenMap}
          onClose={this.closeMap}
          title={title}
          geoLocation={geoLocation}
          address={address}
        />
        {showCarDriveForm && (
          <CarDriveForm
            firmId={firmId}
            isOpen={showCarDriveForm}
            onClose={this.toggleDriveForm}
            countries={carDriveCountries}
          />
        )}
      </div>
    );
  }
}

export default withStyles(s)(withStatsEvents(withPixelRatio(FirmInfo)));



// WEBPACK FOOTER //
// ./src/desktop/routes/service/car-drive/firm/components/FirmInfo/FirmInfo.js